// Constants:
const ROUTES = {
  INDEX: '/'
}


// Exports:
export default ROUTES
